export default "__VITE_ASSET__0HbwYqJy__"